import BritishBroadcastingCorporationWEBP from '../src/assets/BrandEndorsementsSectionAssets/bbc.webp'
import EveningStandardPNG from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.png'
import EveningStandardWEBP from '../src/assets/BrandEndorsementsSectionAssets/eveningstandard.webp'
import IndependentPNG from '../src/assets/BrandEndorsementsSectionAssets/independent.png'
import IndependentWEBP from '../src/assets/BrandEndorsementsSectionAssets/independent.webp'
import MarieClairePNG from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.png'
import MarieClaireWEBP from '../src/assets/BrandEndorsementsSectionAssets/marieclaire.webp'
import TheTelegraphPNG from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.png'
import TheTelegraphWEBP from '../src/assets/BrandEndorsementsSectionAssets/thetelegraph.webp'
import BritishBroadcastingCorporationPNG from './assets/BrandEndorsementsSectionAssets/bbc.png'

export const HOW_OUR_RECIPE_BOXES_WORK = {
  header: 'How our recipe boxes work',
  benefits: [
    {
      title: 'Create your box',
      description: 'Choose your box size (1 to 5 people) and your preferred delivery day.',
    },
    {
      title: 'Choose your recipes',
      description: 'Pick from 175+ recipes every week (there’s something for everyone).',
    },
    {
      title: 'Cook up seriously tasty meals',
      description: 'Get your ingredients delivered and ditch the supermarket chaos.',
    },
    {
      title: 'Flex your subscription',
      description: 'Skip or cancel whenever you like or change how often you get your boxes.',
    },
  ],
}

export const BRAND_ENDORSEMENTS = {
  header: 'Tested and loved by',
  images: {
    britishBroadcastingCorporation: {
      png: BritishBroadcastingCorporationPNG,
      webp: BritishBroadcastingCorporationWEBP,
    },
    eveningStandard: {
      png: EveningStandardPNG,
      webp: EveningStandardWEBP,
    },
    independent: {
      png: IndependentPNG,
      webp: IndependentWEBP,
    },
    marieClaire: {
      png: MarieClairePNG,
      webp: MarieClaireWEBP,
    },
    theTelegraph: {
      png: TheTelegraphPNG,
      webp: TheTelegraphWEBP,
    },
  },
}

export const VALUE_YOU_CAN_TASTE = {
  desktopVideoURL: 'https://production-media.gousto.co.uk/videos/hp-video-desktop.mp4',
  mobileVideoURL: 'https://production-media.gousto.co.uk/videos/hp-video-mobile.mp4',
  header: 'Cook Smarter, Not Harder',
}
export const ENVIRONMENTAL_BENEFITS_HEADING = {
  headingFirst: 'Great food starts with great ingredients',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_ONE = {
  firstLine: 'We pack our boxes with',
  secondLine: 'hand-selected seasonal produce',
  thirdLine: 'whenever possible',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_TWO = {
  firstLine: '100% British',
  secondLine: 'fresh meat from trusted',
  thirdLine: 'UK farms',
}

export const ENVIRONMENTAL_BENEFITS_BULLET_THREE_WITH_URL = {
  firstLine: 'Proud to be a',
  secondLine: 'B Corp™',
  thirdLine: 'using business as a force for good.',
  fourthLine: "It's something that sets us apart from the supermarkets.",
  url: 'https://www.gousto.co.uk/blog/sustainability',
}

export const ENVIRONMENTAL_BENEFITS_DONATION_COPY = {
  firstLine: 'In 2022, we donated',
  secondLine: '970,000+ meals',
  thirdLine: 'worth of food to those in need',
}
